"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tuple = void 0;
/**
 * Factory method for creating a Tuple instance.
 * @param args
 */
const tuple = (...args) => args;
exports.tuple = tuple;
//# sourceMappingURL=tuple.js.map